/**
 * The read-only banner (shell.md §Capability).
 *
 * §3.3's third invariant is explicit that the *enforcement* is a server-side
 * flag rather than a hidden button. So the commit control stays on screen and
 * disabled, and this says why — one clause, because a seat that cannot issue
 * orders needs to know that fact and nothing else about it.
 *
 * Persistent rather than dismissible: it is a property of the seat, not an
 * event, and it is true for the whole exercise.
 */
export function ReadOnlyBanner(): JSX.Element {
  return (
    <div
      data-testid="read-only-banner"
      style={{
        flex: 'none',
        height: 24,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '0 12px',
        background: 'var(--warn-tint)',
        borderBottom: '1px solid var(--warn-tint-border)',
      }}
    >
      <span aria-hidden="true" style={{ width: 5, height: 5, background: 'var(--warn)' }} />
      <span
        style={{
          fontFamily: 'var(--font-data)',
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '.12em',
          textTransform: 'uppercase',
          color: 'var(--warn)',
        }}
      >
        READ-ONLY
      </span>
    </div>
  );
}
